import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationInCircleGrey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 3L9 9.51562L7 9.51562L7 3H9ZM8 13.3125C8.71797 13.3125 9.3 12.7305 9.3 12.0125C9.3 11.2945 8.71797 10.7125 8 10.7125C7.28203 10.7125 6.7 11.2945 6.7 12.0125C6.7 12.7305 7.28203 13.3125 8 13.3125Z",
		fill: "#AEB0B2"
	})]
});
const ForwardRef = forwardRef(SvgExclamationInCircleGrey);
export { ForwardRef as ReactComponent };
